import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { Panel, Grid } from 'rsuite'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectInfoAccordingReviewCycleWidget from '../../../widgets/adminReport/projectInfoAccordingReviewCycle/ProjectInfoAccordingReviewCycleWidget'
import { GetLogActivity, getProjectconsiderlist } from '../../../redux/actions/adminReport'
import AccessLoggerActivityWidget from '../../../widgets/adminReport/accessLoggerActivity/AccessLoggerActivityWidget'

export default function AccessLoggerActivity(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await GetLogActivity({
        // projectCode: data.,
        // logStartDate: '2026-01-05',
        // LogEndDate: '2026-01-06',
        pageNumber: 1,
        pageSize: 25,
      })

      // console.log('ggggg => ', _schema.model)

      if (_schema.success) {
        setSchema(_schema.model)
      }
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isReport>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <AccessLoggerActivityWidget schema={schema.form} header={schema.subHeader} />
    </SidebarProposal>
  )
}
